export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-[#D4D4D8] mt-24">
      <div className="max-w-7xl mx-auto px-6 py-12 grid grid-cols-1 md:grid-cols-4 gap-8">
        <div>
          <div className="mb-3">
            <img src="/logo.png" alt="Baywash" style={{ width: 80, height: "auto", objectFit: "contain" }} />
          </div>
          <p className="text-sm text-[#525252] leading-relaxed">
            The express car wash. On demand. Zero Wait. *
          </p>
        </div>
        <div>
          <div className="font-mono-accent text-xs text-[#002FA7] mb-3">SERVICES</div>
          <ul className="space-y-2 text-sm text-[#525252]">
            <li>Exterior Wash</li>
            <li>Interior Cleaning</li>
            <li>Full Service</li>
            <li>Premium Detail</li>
          </ul>
        </div>
        <div>
          <div className="font-mono-accent text-xs text-[#002FA7] mb-3">COMPANY</div>
          <ul className="space-y-2 text-sm text-[#525252]">
            <li><a href="https://maps.app.goo.gl/T9syy6Qj8Jyna8QBA?g_st=iw" target="_blank" rel="noopener noreferrer" className="hover:text-[#002FA7] transition-colors">Location</a></li>
            <li><a href="https://www.instagram.com/baywashindia?igsh=NTZnMmEzbW51Mm9l" target="_blank" rel="noopener noreferrer" className="hover:text-[#002FA7] transition-colors">Instagram</a></li>
          </ul>
        </div>
        <div>
          <div className="font-mono-accent text-xs text-[#002FA7] mb-3">CONTACT</div>
          <ul className="space-y-2 text-sm text-[#525252]">
            <li><a href="mailto:info@baywashindia.com" className="hover:text-[#002FA7] transition-colors">info@baywashindia.com</a></li>
            <li><a href="tel:+917007206812" className="hover:text-[#002FA7] transition-colors">+91 7007 206 812</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#D4D4D8] py-6 text-center text-xs font-mono-accent text-[#525252]">
        © 2026 BAYWASH INDIA · ALL RIGHTS RESERVED
      </div>
    </footer>
  );
}

